module.exports = __webpack_public_path__ + "img/TZS09535.fdf57437.jpeg";